<template>
  <div class="form_login">
    <!-- <p>componente inicio de sesión</p> -->
    <Login />
    <Footer />
  </div>
</template>

<script>
import Login from '@/components/Login'
import Footer from '@/components/FooterAuth.vue'
export default {
  name: 'signin',
  components: {
    Login,
    Footer,
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Iniciar Sesión',
    // all titles will be injected into this template
    titleTemplate: '%s | Plataforma de eCommerce',
    meta: [
      { charset: 'utf-8' },
      {
        property: 'og:image',
        content: 'https://lubumas.com/img/space3_facebook.png',
      },
      { property: 'og:type', content: 'website' },
      {
        property: 'og:url',
        content: 'https://lubumas.com/',
      },
      {
        property: 'og:title',
        content: 'Lubumas - Plataforma de eCommerce',
      },
      {
        property: 'og:description',
        content:
          'Crea tu tienda online y comience a vender! Hemos creado una herramienta que esta optimizada y enfocada directamente para generar ventas efectivas para su negocio.',
      },

      { property: 'og:site_name', content: 'lubumas' },
      // Twitter card
      { name: 'twitter:card', content: 'summary' },
      {
        name: 'twitter:site',
        content: 'https://lubumas.com/',
      },
      { name: 'twitter:title', content: 'Lubumas | Plataforma de eCommerce' },
      {
        name: 'twitter:description',
        content:
          'Crea tu tienda online y comience a vender! Hemos creado una herramienta que esta optimizada y enfocada directamente para generar ventas efectivas para su negocio',
      },
      // Your twitter handle, if you have one.
      { name: 'twitter:creator', content: '@diegoachury' },
      {
        name: 'twitter:image:src',
        content: 'https://lubumas.com/img/space3_facebook.png',
      },
      // Google / Schema.org markup:
      { itemprop: 'name', content: 'Lubumas | Plataforma de eCommerce' },
      {
        itemprop: 'description',
        content:
          'Crea tu tienda online y comience a vender! Hemos creado una herramienta que esta optimizada y enfocada directamente para generar ventas efectivas para su negocio',
      },
      {
        itemprop: 'image',
        content: 'https://lubumas.com/img/space3_facebook.png',
      },
    ],
  },
}
</script>

<style lang="scss" scoped>
.form_login {
  //position: relative;
  background-color: #f5f5f5;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
